import * as React from 'react';
/**
 *
 * Original name: lock
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A535
 *
 */
export const LockSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M79 43V30a17.02 17.02 0 0 0-17-17h-4a17.02 17.02 0 0 0-17 17v13H25v47a17.018 17.018 0 0 0 17 17h36a17.02 17.02 0 0 0 17-17V43H79ZM47 30a11.012 11.012 0 0 1 11-11h4a11.012 11.012 0 0 1 11 11v13H47V30Zm42 60a11.012 11.012 0 0 1-11 11H42a11.011 11.011 0 0 1-11-11V49h58v41Z", fill: "currentColor" }),
    React.createElement("path", { d: "M60 63c-4.758 0-8 2.9-8 8 0 3.932 1.934 6.551 5 7.546V87h6v-8.454c3.066-1 5-3.614 5-7.546 0-5.1-3.242-8-8-8Z", fill: "currentColor" })));
